import axios from 'axios';
import { getApiBase } from './apiBase';
import {
  CUSTOMER_IMAGE_ACCEPT,
  CUSTOMER_IMAGE_FORMATS_LINE,
  CUSTOMER_IMAGE_UNSUPPORTED_MESSAGE,
  validateCustomerImageFile,
} from './imageUploadValidation';

const API = getApiBase();

export const TREE_COVER_MAX_BYTES = 5 * 1024 * 1024;

export const TREE_COVER_EMPTY_TAGLINE = 'Add a wide cover image to make this archive feel personal.';

export const TREE_COVER_SPECS_LINE = `Recommended: 1600 × 500px · ${CUSTOMER_IMAGE_FORMATS_LINE} · up to 5MB`;

export const TREE_COVER_PRIVACY_LINE = 'Visible only to invited archive members.';

export const TREE_COVER_SETTINGS_GUIDANCE =
  'For best results, use a wide landscape image around 1600 × 500 pixels. After upload, use Adjust cover to shift framing.';

export const TREE_COVER_SETTINGS_PRIVACY =
  'A wide photo that welcomes your family into this archive. Only people you invite can see it.';

export { CUSTOMER_IMAGE_ACCEPT, CUSTOMER_IMAGE_UNSUPPORTED_MESSAGE };

export function validateTreeCoverFile(file) {
  const check = validateCustomerImageFile(file);
  if (!check.ok) {
    return check;
  }

  if (file.size > TREE_COVER_MAX_BYTES) {
    return { ok: false, message: 'This image is too large. Please use a file under 5MB.' };
  }

  return { ok: true };
}

export async function uploadTreeCover(treeId, file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axios.post(`${API}/trees/${treeId}/cover`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return {
    cover_image_url: data.cover_image_url ?? null,
    cover_image_width: data.cover_image_width ?? null,
    cover_image_height: data.cover_image_height ?? null,
    cover_display: data.cover_display ?? null,
  };
}

export async function saveTreeCoverDisplay(treeId, display) {
  const { data } = await axios.patch(`${API}/trees/${treeId}/cover/display`, display);
  return data.cover_display ?? display;
}
